import { getRoute } from '@utils/route';

export const CORPORATE_HEALTH_QUOTE_BUY_ROUTE_URL = '/corporate-health-insurance-quote-buy/*';
export const CORPORATE_HEALTH_QUOTE_BUY_NEW_PAGE_URL = '/corporate-health-insurance-quote-buy';
export const CORPORATE_HEALTH_QUOTE_BUY_REVIEW_PAGE_URL = '/corporate-health-insurance-quote-buy/:orderNumber/review';
export const CORPORATE_HEALTH_QUOTE_BUY_EDIT_PAGE_URL = '/corporate-health-insurance-quote-buy/:orderNumber/edit';
export const CORPORATE_HEALTH_QUOTE_BUY_LOCK_PAGE_URL = '/corporate-health-insurance-quote-buy/:orderNumber/lock';
export const CORPORATE_HEALTH_QUOTE_BUY_PAY_BY_CASH_PAGE_URL = '/corporate-health-insurance-quote-buy/:orderNumber/pay-by-cash';

type RouteParams = {
  orderNumber: string;
};

export const routeCorporateHealthQuoteBuyNewPage = () => getRoute(CORPORATE_HEALTH_QUOTE_BUY_NEW_PAGE_URL);
export const routeCorporateHealthQuoteBuyReviewPage = (routeParams: RouteParams) => getRoute(CORPORATE_HEALTH_QUOTE_BUY_REVIEW_PAGE_URL, { routeParams });
export const routeCorporateHealthQuoteBuyEditPage = (routeParams: RouteParams) => getRoute(CORPORATE_HEALTH_QUOTE_BUY_EDIT_PAGE_URL, { routeParams });
export const routeCorporateHealthQuoteBuyLockPage = (routeParams: RouteParams) => getRoute(CORPORATE_HEALTH_QUOTE_BUY_LOCK_PAGE_URL, { routeParams });
export const routeCorporateHealthQuoteBuyPayByCashPage = (routeParams: RouteParams) => getRoute(CORPORATE_HEALTH_QUOTE_BUY_PAY_BY_CASH_PAGE_URL, { routeParams });
